import React, { FC } from "react";
import CheckCircleIcon from "@mui/icons-material/Check";
import { Box, StepIconProps } from "@mui/material";
import Colors from "../../theme/Colours";

export const StepIcon: FC<StepIconProps> = (props) => {
  const { active, completed, icon } = props;

  const size = {
    width: { xs: "26px", sm: "40px" },
    height: { xs: "26px", sm: "40px" },
  };

  const iconStyle = {
    ...size,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: !(active || completed) ? Colors.progressColor : Colors.background2,
    backgroundColor:
      active || completed ? Colors.progressColor : Colors.background2,
    border: `1px ${Colors.progressColor} ${!(active || completed) && "dashed"}`,
    "&.MuiStepLabel-label": {
      fontSize: "14px",
      fontWeight: "500",
      fontFamily: "Poppins",
      lineHeight: "40px",
      textAlign: "center",
      color: active || completed ? Colors.progressColor : Colors.textColor2,
    },
    zIndex: 1,
  };

  const textStyle = {
    fontSize: { xs: "10px", sm: "14px" },
    fontWeight: "500",
    fontFamily: "Poppins",
    lineHeight: { xs: "26px", sm: "40px" },
    textAlign: "center",
  };

  return (
    <Box sx={iconStyle}>
      {icon === 1 ? (
        <CheckCircleIcon
          sx={{
            color: Colors.background2,
            fontSize: { xs: "16px", sm: "24px" },
          }}
        />
      ) : (
        // <div>0{+icon! - 1}</div>
        <Box sx={textStyle}>
          {typeof icon === "number" ? `0${icon - 1}` : "0"}
        </Box>
      )}
    </Box>
  );
};
